// Copyright (c) 2016 Deere & Company

import '../../../../shared/components/labeled-string/index.scss';
import 'react-datepicker/dist/react-datepicker.css';
import React, {PropTypes} from 'react';
import {
    getCorrectDateValue,
    transformDateValue
} from '../../../../shared/services/build-date';
import {FormattedMessage} from 'react-intl';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';
import WarrantyDatePicker from '../.././../../shared/components/warranty-date-picker';

const handleLetterSentDateChange = props => newDate => props.onItemChange('letterSentDate', getCorrectDateValue(newDate));

const CertifiedLetterSent = props =>
    <div className='labeled-string'>
        <span className='data-label'>
            <sup>{'*'}</sup> <FormattedMessage id='CERTIFIED_LETTER_SENT'/>
        </span>
        <WarrantyDatePicker
            onChange={handleLetterSentDateChange(props)}
            selected={transformDateValue(props.statusChangeRequest.lastContactDetails.letterSentDate)}
        />
    </div>;

CertifiedLetterSent.displayName = 'CertifiedLetterSent';
CertifiedLetterSent.propTypes = {
    onItemChange: PropTypes.func.isRequired,
    statusChangeRequest: PropTypes.instanceOf(StatusChange).isRequired
};

export default CertifiedLetterSent;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/input-fields/certified-letter-sent.js